import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../../store/createStore";
import { ContainerButton, ContainerStore } from "./styles";
import { FiChevronDown } from "react-icons/fi";
import { viewModal } from "../../store/modules/parameter/actions";
import MultiStore from "../Multistore";
import { config } from "../../config";

const MultiStoreSelected: React.FC = () => {
    const dispatch = useDispatch();
    const { multistoreSelected } = useSelector((state: StoreState) => state.parameter);

    if (!multistoreSelected.store_id) {
        return null;
    }

    if (!config.isAllowedMultistore) {
        return (
            <ContainerStore>
                <span>{multistoreSelected.name}</span>
                <span>{multistoreSelected.city} - {multistoreSelected.country}</span>
        </ContainerStore>
        )
    }

    return (
        <ContainerButton onClick={() => {
            dispatch(viewModal(MultiStore, { width: '50%', height: '100%', buttonClose: true }, true));
        }}>
            <div>
                <span>{multistoreSelected.name}</span>
                <span>{multistoreSelected.city} - {multistoreSelected.country}</span>
            </div>
            <FiChevronDown size={10} />
        </ContainerButton>
    )
}

export default MultiStoreSelected;